function parseImport(file, options, onComplete) {
    cc.assetManager.parser.parseImport(file, options, (err, result) => {
        // console.log("result.__depends__", err,file, result?.__depends__)
        if (result && result.__depends__) {
            // console.log(file,result.__depends__)
            for (let i = 0; i < result.__depends__.length; i++) {
                let depend = result.__depends__[i]
                // if(depend.uuid == "0c1d8808-34d2-4824-81cc-35f50e237a24"){
                //     depend.uuid = "10a8c7fc-53b9-4d46-bc64-ebcf1423414d"
                // }
            }
        }
        onComplete && onComplete(err, result);
    })
}

cc.assetManager.parser.register("import", parseImport)